import { CobrowsingInfo } from '@agent/core/store/cobrowsing/cobrowsing.model';
import { createAction, props } from '@ngrx/store';

export const InitCobrowsing = createAction(
  '[Agent/Cobrowsing] init cobrowsing',
  props<{
    info: CobrowsingInfo;
  }>()
);

export const StartCobrowsing = createAction(
  '[Agent/Cobrowsing] start cobrowsing',
  props<{
    info: CobrowsingInfo;
  }>()
);

export const StartCobrowsingError = createAction(
  '[Agent/Cobrowsing] start cobrowsing error',
  props<{
    info: CobrowsingInfo;
  }>()
);

export const CobrowsingStarted = createAction(
  '[Agent/Cobrowsing] cobrowsing started',
  props<{
    info: CobrowsingInfo;
  }>()
);

export const RemoveCobrowsing = createAction(
  '[Agent/Cobrowsing] remove cobrowsing',
  props<{
    bookingId: string;
  }>()
);

export const EndCobrowsing = createAction(
  '[Agent/Cobrowsing] end cobrowsing',
  props<{
    bookingId: string;
  }>()
);

export const CobrowsingEnded = createAction(
  '[Agent/Cobrowsing] cobrowsing ended',
  props<{
    bookingId: string;
  }>()
);

export const CobrowsingSessionUpdated = createAction(
  '[Agent/Cobrowsing] cobrowsing session updated',
  props<{
    info: CobrowsingInfo;
  }>()
);
